import { Avatar, AvatarStack, ButtonRow, Button, HeadingRow, ContextMenu, ContextMenuItem } from "cai-fusion"
import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"

// Icons
import { ReactComponent as IconComment } from "../../../../images/icon-comment.svg"
import { ReactComponent as IconInfo } from "../../../../images/icon-info.svg"
import { ReactComponent as IconOrg } from "../../../../images/icon-org.svg"
import { ReactComponent as IconPerson } from "../../../../images/icon-person.svg"
import { ReactComponent as IconShare } from "../../../../images/icon-share.svg"
import { ReactComponent as IconRegenerate } from "../../../../images/icon-regenerate.svg"
import { ReactComponent as IconRename } from "../../../../images/icon-rename.svg"
import { ReactComponent as IconTrash } from "../../../../images/icon-trash.svg"

// Blocks and callouts
import SiftOpportunityAICallout from "./blocks/siftOpportunityAICallout"
import SiftOpportunityOverviewBlock from "./blocks/siftOpportunityOverviewBlock"
import SiftOpportunityInfoBlock from "./blocks/siftOpportunityInfoBlock"
import SiftOpportunityFeedbackBlock from "./blocks/siftOpportunityFeedbackBlock"
import SiftOpportunityFileBlock from "./blocks/siftOpportunityFileBlock"
import SiftOpportunityInsightBlock from "./blocks/siftOpportunityInsightBlock"

// Modals and drawers
import DeleteOpportunityModal from "./overlay/deleteOpportunityModal"
import EditOpportunityOverviewDrawer from "./overlay/editOpportunityOverviewDrawer"
import OpportunityAddFileModal from "./overlay/opportunityAddFileModal"
import OpportunityDiscussionDrawer from "./overlay/opportunityDiscussionDrawer"
import OpportunityHistoryDrawer from "./overlay/opportunityHistoryDrawer"
import RenameOpportunityModal from "./overlay/renameOpportunityModal"
import ShareOpportunityDrawer from "./overlay/shareOpportunityDrawer"
import UpdateOpportunityStateModal from "./overlay/updateOpportunityStateModal"

// Components, hooks, and contexts from elsewhere in the repo
import { useTransientVisibility } from "../../../fusion/Contexts/VisualContext"
import { useSiftV2 } from "../../contexts/siftV2Context"
// import AvatarStack from "../../../fusion/AvatarStack"
// import { Avatar } from "../../../fusion"

const avatarAI = require("../../../../images/avatar-ai-classic.png");

const SiftViewOpportunity = () => {

    const { show, hide } = useTransientVisibility();
    const params = useParams();
    const { currOpp, currOppId, setCurrOppId, setCurrAction } = useSiftV2();

    useEffect(() => {
        if (currOppId != params.OppId) {
            setCurrOppId(params.OppId);
            document.title = "Sift V2 - Opportunity Details"
        }
    }, [])

    const statusOrder = ["Draft", "Pre-qualification", "SME Review", "Bid", "No Bid"]

    const [stateToChangeTo, setStateToChangeTo] = useState("");

    const [hideLastViewedCallout, setHideLastViewedCallout] = useState(false);
    const [hideStatusContextMenu, setHideStatusContextMenu] = useState(true);
    const [hideGenOpsContextMenu, setHideGenOpsContextMenu] = useState(true);

    return (
        <>
            <div className="o-page-section o-page-section l-pt-none">
                <div className="o-page-section__content-container o-page-section__content-container--med-wide-fixed-width l-pt-none l-mt-neg-sm">
                    <div className="l-row">
                        <div className="col-12">
                            <HeadingRow
                                size={2}
                                title={currOpp?.request?.title ?? "View Opportunity"}
                                eyebrow="Opportunity"
                            >
                                <AvatarStack className="l-mr-xs" label="Review Team">
                                    {currOpp?.users?.map((user, index) => (
                                        <Avatar Icon={IconPerson} alt={user} key={index} />
                                    ))}
                                </AvatarStack>
                                {/* <ContextMenu
                                    isHidden={hideGenOpsContextMenu}
                                    onClick={() => setHideGenOpsContextMenu(!hideGenOpsContextMenu)}
                                    onBlur={() => setHideGenOpsContextMenu(true)}
                                >
                                    <ContextMenuItem Icon={IconRename} name="Rename Opportunity" onClick={() => {setHideGenOpsContextMenu(true); show('RenameOpportunityModal')}}/>
                                    <ContextMenuItem Icon={IconShare} name="Share Opportunity" onClick={() => {setHideGenOpsContextMenu(true); show('ShareOpportunityDrawer')}}/>
                                    <ContextMenuItem Icon={IconInfo} name="View History" onClick={() => {setHideGenOpsContextMenu(true); show('OpportunityHistoryDrawer')}}/>
                                    <ContextMenuItem Icon={IconTrash} danger name="Delete Opportunity" onClick={() => {setHideGenOpsContextMenu(true); show('DeleteOpportunityModal')}}/>
                                </ContextMenu> */}
                            </HeadingRow>
                            <div className="l-row l-mt-xs l-mb-xs">
                                <div className="col-6">
                                    <ButtonRow alignLeft>
                                        {/* This is a mess and I absolutely hate it. */}
                                        <div 
                                            className={`o-button-context-menu ${!hideStatusContextMenu && "o-button-context-menu--shown"}`}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                if (!e.currentTarget.contains(e.relatedTarget)) {
                                                    setHideStatusContextMenu(true);
                                                }
                                            }}
                                        >
                                            <button 
                                                className="a-tag a-tag--interactive o-button-context-menu__toggle-button" 
                                                onClick={() => {
                                                    setHideStatusContextMenu(!hideStatusContextMenu);
                                                }}
                                            >
                                                <IconRegenerate className="a-tag__icon svg-inject" />
                                                <p className="a-tag__label">
                                                    <span className="a-tag__category">Status: </span>
                                                    <span className="a-tag__value"><strong>{currOpp?.request?.currentState?.name ?? ""}</strong></span>
                                                </p>
                                            </button>
                                            <ul className="m-context-menu o-button-context-menu__menu">
                                                {/* These are conditional renders for each state item. If we're further along / on a state, we don't want to show previous ones. */}
                                                {/* TODO: EXCEPT if the user is an admin */}
                                                { 
                                                    currOpp?.request?.currentState?.actions?.map(act => 
                                                        <ContextMenuItem name={act.name} Icon={IconRegenerate} onClick={() => {
                                                            setStateToChangeTo(act.name);
                                                            setCurrAction(act);
                                                            show('UpdateOpportunityStateModal');
                                                            setHideStatusContextMenu(true);
                                                        }} />
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </ButtonRow>
                                </div>
                                <div className="col-6">
                                    <ButtonRow>
                                        {/* Comments Button */}
                                        {/* <button className="a-tag a-tag--interactive" onClick={() => show('OpportunityDiscussionDrawer')}>
                                            <IconComment className="a-tag__icon svg-inject" style={{width: 16}} />
                                            <p className="a-tag__label">{placeholderChat?.length ?? 0} Comment{placeholderChat?.length === 1 ? "" : "s"}</p>
                                        </button> */}
                                        {/*<button className="a-tag a-tag--interactive" onClick={() => show('ShareOpportunityDrawer')}>*/}
                                        {/*    <IconOrg className="a-tag__icon svg-inject" />*/}
                                        {/*    <p className="a-tag__label">Shared with {currOpp?.users?.length ?? 0} {currOpp?.users?.length === 1 ? "person" : "people"}</p>*/}
                                        {/*</button>*/}
                                    </ButtonRow>
                                </div>
                            </div>
                            <div className="l-row">
                                <div className="col-12">
                                    {false && <SiftOpportunityAICallout onDismiss={() => setHideLastViewedCallout(true)} />}
                                </div>
                            </div>
                            <div className="l-row l-pt-xs">
                                <div className="col-7">
                                    <SiftOpportunityOverviewBlock />
                                </div>
                                <div className="col-5">
                                    <SiftOpportunityInfoBlock />
                                    {/* <SiftOpportunityFeedbackBlock /> */}
                                    {/* <SiftOpportunityInsightBlock /> */}
                                    <SiftOpportunityFileBlock />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Every single modal and drawer. Yes, there are this many. */}
            <DeleteOpportunityModal />
            <EditOpportunityOverviewDrawer />
            <OpportunityAddFileModal />
            {/* <OpportunityDiscussionDrawer /> */}
            {/* <OpportunityHistoryDrawer /> */}
            <RenameOpportunityModal />
            <ShareOpportunityDrawer />
            <UpdateOpportunityStateModal newState={stateToChangeTo} />
        </>
    )
}

export default SiftViewOpportunity